<div class="integration-badge integration-badge--{{ integration }}">
  {{ integration[0] | uppercase }}
</div>
